import React from 'react';
import PropTypes from 'prop-types';

const OverviewTableRow = (props) => {
    return(
        <tr id={props.id}>
            <td className="col-xs-6 col-sm-4 col-md-2"> 
                {props.label}
            </td>
            <td className="col-xs-6 col-sm-8 col-md-10">
                {props.children && props.children}
                {!props.children && props.value}
            </td>
        </tr>
    );
};

OverviewTableRow.propTypes = {
    id: PropTypes.string,
    label: PropTypes.string,
    children: PropTypes.node,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]) 
};

export default OverviewTableRow;


// WEBPACK FOOTER //
// ./src/components/base/Table/OverviewTableRow.js